import React from "react";
import { Modal, ModalBody } from "react-bootstrap";
import Image from "../Reusable/Image";
import { ConfirmationModalTheme } from "../../Utils/Enums";
import SubmitButtonTwo from "../Reusable/Buttontwo";
import { Link } from "react-router-dom";
import RoutesPath from "../../Utils/RoutesPath";

const PopupModal = ({ showModal, setShowModal, text, icon, theme = ConfirmationModalTheme.theme,extraclass,linkTo,titlebutton,className}) => {
  const formattedText = text.replace(
    "successfully",
    "<span style='font-weight: bold; font-size: 1.0em;'>Successfully</span>"
  );
  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      dialogClassName="my-0"
      centered // Center the modal vertically and horizontally
      aria-labelledby="exampleModalToggleLabel2"
      contentClassName="p-0 bg-transparent border-0 shadow-none m-0"
    >
      <ModalBody className="p-0">
        <div className="w-100 d-flex flex-column">
          <div className="modal_icon_background  mx-auto">
            <Image src={icon} style={{ width: "75%", aspectRatio: 1 }} />
          </div>

          <div className={`modal-content resetpopupstyling ${extraclass} clip_content align-items-center d-flex flex-column`}>
            <div className="modal-header p-0 justify-content-center align-items-center d-flex flex-column" style={{borderBottom:'0px'}}>
              <div style={{marginTop:'80px'}}>
                <h1 className="Banner-description fw-600 text_small mb-3 text-center mt-3" id="exampleModalToggleLabel2" dangerouslySetInnerHTML={{ __html: formattedText }}/>
              </div>
              <div className="modal-footer p-0 justify-content-center w-100" style={{ borderTop: "0px" }}>
                <Link to={linkTo} className="w-100">
                  <SubmitButtonTwo title={titlebutton} className={className} />
                </Link>
              </div>
            </div>
           
            
          </div>

          <div className="modal_border_bottom bg_red" style={{background: theme.primary}}/>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PopupModal;
